import { useIntl } from 'react-intl'

import { PageWorkflowStatus } from 'shared/types/global'
import Dropdown from 'shared/ui/Dropdown'
import Flex from 'shared/ui/Flex'
import PageStatus from 'shared/ui/PageStatus'
import { PAGE_STATUS_LABEL_IDS } from 'shared/ui/PageStatus/constants'
import { usePageStatusOptions } from 'shared/ui/PageStatus/usePageStatusOptions'
import Text from 'shared/ui/Text'

type PageStatusDropdownProps = {
  status: PageWorkflowStatus
  onChange: (status: PageWorkflowStatus) => void
  disabled?: boolean
}

const PageStatusDropdown: React.FC<PageStatusDropdownProps> = ({
  status,
  onChange,
  disabled = false
}) => {
  const { formatMessage } = useIntl()
  const options = usePageStatusOptions()

  return (
    <Dropdown
      fullWidth
      value={status}
      options={options}
      onChange={onChange}
      disabled={disabled}
      renderTrigger={() => (
        <Flex alignItems="center" columnGap={8}>
          <PageStatus
            withIcon
            status={status}
            size={22}
          />
          <Text
            size={13}
            text={formatMessage({
              id: PAGE_STATUS_LABEL_IDS[status]
            })}
            color={theme => theme.color.base.c7}
            weight={600}
          />
        </Flex>
      )}
    />
  )
}

export default PageStatusDropdown
